export default __webpack_public_path__ + "static/media/github.3f2154ab.svg";